import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, [
    _createVNode("path", {
      "stroke-linecap": "round",
      d: "M8 20.5h9.5a1 1 0 001-1V6"
    }),
    _createVNode("path", {
      d: "M5 4.075A1.07 1.07 0 016.066 3h9.444a1.07 1.07 0 011.066 1.075v13.41a1.07 1.07 0 01-1.066 1.075H6.066A1.07 1.07 0 015 17.485V4.075zm3.222 10.213a.79.79 0 010-1.256 4.185 4.185 0 012.566-.875c.965 0 1.855.326 2.566.875a.79.79 0 010 1.256 4.185 4.185 0 01-2.566.876 4.185 4.185 0 01-2.566-.876zm2.564-2.884c1.096 0 1.985-1.12 1.985-2.504 0-1.382-.889-2.503-1.985-2.503C9.689 6.397 8.8 7.517 8.8 8.9s.888 2.504 1.985 2.504z",
      "clip-rule": "evenodd"
    })
  ]))
}